import React, { useRef } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap';
import './form.scss';
import { useState } from 'react';
import { callApi, getUrlencoded } from '../../../../common/utils/salesforce';
import RecaptchaEnterprise from '../../../../common/components/captcha/recaptcha-enterprise';
import { RECAPTCHA_SITE_KEY } from '../../../../common/utils/constant';
import { useAppContext } from '../../../../common/context';
import FormFields from '../../../../common/components/formFields';

const initVal = {
  lead_source: "Website",
  phone: '',
  last_name: '',
  first_name: '',
  email: '',
  Message__c: ''
}

function ContactForm({data}) {
  const recaptchaRef = useRef();
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [token, setToken] = useState(null);
  const [tokenError, setTokenError] = useState(null);
  
  const [values, setValues] = useState(initVal);
  const [validated, setValidated] = useState(false);
  const [isValid, setIsValid] = useState(false);
  // const hyphenImg = '/images/common/icons/Vector 59.png';
  const { environment } = useAppContext();

  const onChange = e => {
    const { name, value } = e.target;
    const inputRegex = /^\s*$/;
  
    if (name === 'email') {
      const newEmail = e.target.value;

      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      setIsValid(emailRegex.test(newEmail));
    }
    if(name === 'last_name'){
      if(!inputRegex.test(value)){
        setValues({ ...values, [name]: value });
      } else{
        setValues({ ...values, [name]: '' });
      }
    } else {
      setValues({ ...values, [name]: value });
    }
  }

  const onChangeCaptch = token => {

    setTokenError(null);
    setToken(token);
  }

  const resetForm = () => {
    setTokenError(null);
    setToken(null);
    setError(null);
    setValues(initVal);
  }
  const clearMessage = () => {
    setTokenError(null);
    setMessage(null);
    setError(null);
  }
  const onSubmit = e => {
    e.preventDefault();
    clearMessage();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();

    }
    if (!token) {
      setValidated(false);
      setTokenError('Please verify that you are not a robot.');

    }
    setValidated(true);

    const { last_name, email } = values;
    try {
    if (token !== null && (last_name !== '' && email !== '') && isValid) {
      for (let key in values) {
        if (values.hasOwnProperty(key)) {
          values[key] = values[key].trim();
        }
      }
      const urlencoded = getUrlencoded(values);
      callApi(urlencoded, environment)
        .then((response) => {

          if (response) {
            resetForm();
            setValidated(false);
            if (recaptchaRef.current) {
              recaptchaRef.current.reset(); 
            }
            setMessage('Thank you for your message. It has been sent.');
          }
          return response.text();
        })
        .catch((error) => {
          console.error(error);
          setError('There was an issue with the submission. Please try again later.'); 
        });
    } else {
      setError('One or more fields have an error. Please check and try again.');

    }
  } catch (error) {
    console.error('Unexpected error during form submission:', error);
    setError('An unexpected error occurred. Please try again later.'); 
  }
  }

  return (
    <div className='ContactForm-wrapper-page'>
      <Row>
        <Col md={6} sm={12}>
          <div className='contactForm-tilte'>
           {data?.headline ? data?.headline : 'Contact a Best Buy Ads Partner & Category Marketer'} 
          </div>
        </Col>
        <Col md={6} sm={12}>
          <div className='contactForm-container-section'>
            <Form noValidate validated={validated} className='child'
              onSubmit={onSubmit}
            >
              <input value="" type="hidden" name="phone" onChange={onChange} />

              <FormFields
                name="last_name"
                label="First Name"
                type="text"
                value={values.last_name}
                onChange={onChange}
                placeholder="Name"
                required
                isValid={isValid}
                maxLength={80}
                errorMessage="Please fill out this field."
                backgroundColor="#f0f0f0"
              />
              <FormFields
                name="email"
                label="Business Email"
                type="email"
                value={values.email}
                onChange={onChange}
                placeholder="Email"
                required
                isValid={isValid}
                maxLength={100}
                isInvalid={!isValid && values.email.length > 0}
                errorMessage="Please enter a valid email address"
                backgroundColor="#f0f0f0"
              />
              <FormFields
                name="Message__c"
                label="Message__c"
                type="text"
                value={values.Message__c}
                onChange={onChange}
                placeholder="Message"
                required={false}
                isValid={isValid}
                maxLength={400}
                backgroundColor="#f0f0f0"
              />
              <div className="recaptcha-container"> 
                <RecaptchaEnterprise
                  sitekey={RECAPTCHA_SITE_KEY}
                  setToken={onChangeCaptch} 
                  ref={recaptchaRef} 
                  />
                {tokenError && <div className="captch-error">{tokenError}</div>}
              </div>
              <div className='submitBtn-alignment'>
                <Button className='submitBtn' variant="primary" type='buttton' id="btnSubmit">Submit</Button>
              </div>
              {(error || message) && (
                <div className='container error-container'>
                  {error && <div className="article-error">{error}</div>}
                  {message && <div className="article-success">{message}</div>}
                </div>
              )}

            </Form>
          </div>
        </Col>
      </Row>

    </div>
  )
}

export default ContactForm